import { Bell } from "lucide-react";
import { SectionCard } from "./identityForm";

/**
 * "Notifications" (#1673, D466) — an honest card, with no switches.
 *
 * It used to offer three switches (training reminders, email, mobile phone)
 * and a save button. All of it was local state: the button raised a success
 * toast with no request behind it, and a reload put every switch back. The
 * app sends no notification by email or text (D404); notifications appear in
 * the bell inside the app. So the card says
 * exactly that and offers nothing to switch.
 *
 * Do not put a control back here until a send path exists and the choice is
 * stored (email is decided on #1515; the held preferences work is #738). A
 * text-message promise also stays out: "we don't send text messages" is
 * said on the account card and pinned by `smsConsentGuard` (D404).
 *
 * THE FOLD arrives closed, like the other settings sections, and its header
 * state is the one fact it can state truthfully: "In the app".
 */
export default function NotificationsCard({ appearance } = {}) {
  return (
    <SectionCard
      icon={Bell}
      title="Notifications"
      desc="Where your notifications appear."
      collapsible
      defaultOpen={false}
      summary="In the app"
      toggleTestid="settings-notifications-toggle"
      usageItem="notifications"
      testid="settings-notifications-card"
      appearance={appearance}
    >
      <p className="text-sm text-slate-600" data-testid="settings-notifications-note">
        Notifications appear in the bell at the top of the app. Email and text notifications are not available yet.
      </p>
    </SectionCard>
  );
}
